export type Variants = readonly [string, readonly string[]];

/**
 * @deprecated use multiple input as component props
 */
export const ComponentVariant = function ([defaultVariant, allVariants]: Variants) {
  return function <T extends { variant: string }, K extends 'variant'>(target: T, propertyKey: K) {
    const valueKey = '__variant__';
    Object.defineProperty(target, propertyKey, {
      set: function (this: any, value: string) {
        const variantArr = value.split(' ');
        const variantValid = variantArr.some(variant => allVariants.includes(variant));
        if (variantValid) {
          this[valueKey] = value;
        } else {
          console.warn(
            `Variant "${value}" not found, setting default (${defaultVariant}) instead`,
            target,
          );
          this[valueKey] = defaultVariant;
        }
      },
      get: function (this: any) {
        return this[valueKey] || defaultVariant;
      },
    });
  };
};
